export const ABOUT_PEOPLE = [
    {
        name: 'Niama BELAYACHI',
        role: 'Présidente',
        imageUrl: '/assets/images/members/BELAYACHI_Niama.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Oscar LAHAIE',
        role: 'Vice-Président externe',
        imageUrl: '/assets/images/members/LAHAIE_Oscar.png',
        linkedinUrl: 'https://www.linkedin.com/in/oscar-lahaie/'
    },
    {
        name: 'Reina HOBLOS',
        role: 'Secrétaire Général',
        imageUrl: '/assets/images/members/defaultMemberIcon.png',
        linkedinUrl: ''
    },
    {
        name: 'Martin TONOLI',
        role: 'Trésorier',
        imageUrl: '/assets/images/members/TONOLI_Martin.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Théo HARI',
        role: 'Vice-trésorier',
        imageUrl: '/assets/images/members/HARI_Theo.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Eléa-Rose THOMAS',
        role: 'Communication',
        imageUrl: '/assets/images/members/THOMAS_Elea_Rose.png',
        linkedinUrl: 'https://www.linkedin.com/in/el%C3%A9a-rose-thomas-7680b4340/'
    },
    {
        name: 'Clément DI GALLO',
        role: 'Directeur Services Informatiques',
        imageUrl: '/assets/images/members/DI_GALLO_Clement.jpg',
        linkedinUrl: 'https://www.linkedin.com/in/cl%C3%A9ment-di-gallo/'
    },
    {
        name: 'Sébastien TRINDER',
        role: 'Trésorerie',
        imageUrl: '/assets/images/members/TRINDER_Sebastien.jpg',
        linkedinUrl: ''
    },
    {
        name: 'PEYRETAILLADE Florian',
        role: 'Ressources Humaines',
        imageUrl: '/assets/images/members/defaultMemberIcon.png',
        linkedinUrl: ''
    },
    {
        name: 'Simon ROSOL',
        role: 'Responsable Prospection',
        imageUrl: '/assets/images/members/ROSOL_Simon.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Dylan DOLE',
        role: 'Responsable Qualité',
        imageUrl: '/assets/images/members/DOLE_Dylan.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Jean-Charles VENTE',
        role: "Responsable Suivi d'Études",
        imageUrl: '/assets/images/members/VENTE_Jean-Charles.jpg',
        linkedinUrl: 'https://www.linkedin.com/in/jean-charles-vente/'
    },
    {
        name: 'Camille RAKOTOARISOA',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/RAKOTOARISOA_Camille.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Camilla SCHOESER',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/SCHOESER_Camilla.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Armel KI',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/KI_Armel.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Aurélien DUVET',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/DUVET_Aurelien.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Nathan ARCARO',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/ARCARO_Nathan.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Yassine BENDALI',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/BENDALI_Yassine.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Rudy LENOBLE',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/LENOBLE_Rudy.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Etienne NARDOU',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/NARDOU_Etienne.jpg',
        linkedinUrl: ''
    },
    {
        name: 'Théo PINCHON',
        role: 'Chef de Projet',
        imageUrl: '/assets/images/members/PINCHON_Theo.jpg',
        linkedinUrl: ''
    }
]

export const PRESTATIONS_POSTS = [
    {
        id: 'data-ai',
        title: 'Intelligence de la Donnée & Aide à la Décision',
        description:
            "<p>La <strong>performance</strong> d'une organisation ne se mesure plus seulement à la quantité de données collectées, mais à sa capacité à les transformer en <strong>décisions éclairées</strong>. Nous mobilisons la modélisation probabiliste, le <em>Deep Learning</em> et l’analyse spectrale pour extraire la <strong>valeur stratégique</strong> de vos flux, qu'ils soient textuels, numériques ou visuels.</p>" +
            "<p>Deux parcours d’accompagnement sont proposés selon votre besoin :</p>" +
            "<ul>" +
            "<li><strong>Création</strong> : structurer et fiabiliser une base de données depuis zéro.</li>" +
            "<li><strong>Contrôle</strong> : auditer, qualifier et optimiser un patrimoine data existant.</li>" +
            "</ul>" +
            "<p>De l’<strong>automatisation</strong> du contrôle qualité par vision industrielle à la mise en place d'architectures prédictives, nous structurons vos actifs informationnels pour <strong>anticiper</strong> les évolutions de votre marché et <strong>optimiser durablement</strong> votre chaîne de valeur.</p>",
        imageUrl: '/assets/images/illustrations/ia.jpeg',
        images: [
            '/assets/images/icons/python.png',
            '/assets/images/icons/mysql.webp',
            '/assets/images/icons/mssql.png',
            '/assets/images/icons/oracle.png',
            '/assets/images/icons/java.png'
        ],
        services: [
            {
                id: 'vision-qa',
                title: 'Audit et Valorisation du Patrimoine Data',
                summary: 'Création ou contrôle d\'un socle data exploitable pour le pilotage métier.',
                details:
                    '<p>Cette prestation transforme des gisements de données brutes en actifs stratégiques exploitables pour le pilotage de l\'entreprise.</p><p>Elle se décline en deux approches complémentaires selon le contexte du projet.</p><ul><li><strong>Création</strong> : extraction, transformation et chargement des données pour garantir une base saine et normalisée.</li><li><strong>Contrôle qualité</strong> : inventaire des sources, évaluation de la cohérence sémantique et validation de la valeur des données.</li></ul>'
            },
            {
                id: 'predictive-bi',
                title: 'Modélisation Prédictive, Données & IA',
                summary: 'Exploitation des données historiques pour anticiper et optimiser les décisions.',
                details:
                    '<p>Cette prestation transforme vos données historiques en moteur d\'anticipation grâce à des approches statistiques et d\'apprentissage automatique.</p><ul><li><strong>Deep Learning</strong> : interprétation de flux financiers, informatifs, textuels ou de signaux complexes.</li><li><strong>Optimisation par apprentissage</strong> : stabilisation des processus via les principes du point-fixe et des critères d\'optimalité.</li><li><strong>Recherche opérationnelle</strong> : aide à la planification, à l\'ordonnancement et à la résolution de contraintes métier.</li></ul>'
            },
            {
                id: 'nlp-classification',
                title: 'Reconnaissance & Visualisation de Données',
                summary: 'Traitement d\'images et de flux visuels pour extraire de l\'information exploitable.',
                details:
                    '<p>Cette prestation couvre la chaîne complète de traitement des données visuelles, de l\'amélioration initiale à l\'interprétation finale.</p><ul><li><strong>Traitement numérique</strong> : seuillage, filtrage et restauration d\'images.</li><li><strong>Segmentation et analyse morphologique</strong> : extraction de zones d\'intérêt et caractérisation des objets.</li><li><strong>Reconnaissance de formes</strong> : classification et validation des détections complexes.</li><li><strong>Optimisation et sécurisation</strong> : compression, transmission et tatouage numérique.</li><li><strong>Navigation autonome</strong> : intégration de flux multi-capteurs pour la détection d\'obstacles.</li></ul>'
            },
            {
                id: 'big-data-infra',
                title: 'Ingénierie des Infrastructures de Données Massives',
                summary: 'Mise en place d\'un environnement robuste pour collecter et traiter de grands volumes.',
                details:
                    '<p>Cette prestation garantit un environnement capable de collecter, stocker et traiter des flux de données à grande échelle pour alimenter vos outils de décision.</p><ul><li><strong>Architectures d\'intégration</strong> : interrogation uniforme de sources hétérogènes (SQL, NoSQL, JSON, XML).</li><li><strong>Pipelines ETL</strong> : extraction, normalisation et chargement automatisés vers des entrepôts structurés.</li><li><strong>Stockage distribué</strong> : déploiement de solutions type HDFS et Data Lake pour la disponibilité des données.</li><li><strong>Performance et indexation</strong> : optimisation du partitionnement, du caching et des temps de réponse.</li><li><strong>Traitement temps réel</strong> : mise en place de frameworks modernes comme Spark et Kafka.</li></ul>'
            }
        ]
    },
    {
        id: 'digital-engineering',
        title: 'Ingénierie Digitale et Développement',
        description:
            "<p>L’<strong>agilité</strong> d’une entreprise moderne repose sur la solidité de son <strong>infrastructure</strong> numérique et l’<strong>ergonomie</strong> de ses interfaces. Au-delà du simple développement, l'ingénierie digitale consiste à bâtir des écosystèmes robustes où le <i>Web</i>, le <i>Mobile</i> et la modernisation applicative s’articulent pour garantir une <strong>disponibilité</strong> totale et une <strong>intégrité</strong> durable de vos services.</p>" +
            "<p>Nous concevons des solutions sur mesure, performantes et sécurisées, adaptées aux besoins métiers et aux environnements techniques exigeants.</p>",
        imageUrl: '/assets/images/illustrations/mobile.jpeg',
        images: [
            '/assets/images/icons/jquery.png',
            '/assets/images/icons/jsp.png',
            '/assets/images/icons/php.png',
            '/assets/images/icons/symfony.png',
            '/assets/images/icons/java.png',
        ],
        services: [
            {
                id: 'web-dev',
                title: 'Développement Web',
                summary: 'Conception d\'applications web robustes, évolutives et sécurisées.',
                details: `
          <p>Cette prestation couvre la conception complète d'applications web performantes et pérennes.</p>
          <ul>
             <li><strong>Architecture Front-end & Back-end</strong> : conception complète de l'interface visuelle et de la logique serveur (APIs).</li>
             <li><strong>Hébergement & Déploiement Cloud</strong> : configuration de serveurs robustes pour assurer la disponibilité constante de votre site.</li>
             <li><strong>CMS & E-commerce</strong> : mise en place d'outils permettant de gérer vos catalogues et vos ventes en autonomie.</li>
             <li><strong>Référencement & Performance</strong> : optimisation technique pour un chargement rapide et une meilleure visibilité sur les moteurs de recherche.</li>
          </ul>
         `
            },
            {
                id: 'mobile-app',
                title: 'Développement Mobile',
                summary: 'Applications mobiles iOS/Android connectées à votre écosystème SI.',
                details: `
          <p>Nous développons des applications mobiles fluides, intuitives et adaptées aux usages iOS/Android.</p>
          <ul>
             <li><strong>Développement natif</strong> : création d'applications performantes et adaptées au système d'exploitation.</li>
             <li><strong>Expérience tactile & mobilité</strong> : interfaces pensées pour une navigation intuitive en mouvement.</li>
             <li><strong>Mode hors-ligne</strong> : conservation locale des données pour garder l'application fonctionnelle sans internet.</li>
             <li><strong>Exploitation du hardware</strong> : usage de la caméra, du GPS, de l'accéléromètre et des notifications push.</li>
          </ul>
         `
            },
            {
                id: 'ux-modernization',
                title: 'Relooking Digital & Expérience Utilisateur',
                summary: 'Refonte d\'interfaces et modernisation de systèmes pour améliorer l\'adoption.',
                details:
                    '<ul><li><strong>Design d\'Expérience (UX/UI)</strong> : nous plaçons l\'utilisateur au centre pour maximiser l\'adoption de vos outils et la fluidité des parcours.</li><li><strong>Architecture & Modernisation de Systèmes</strong> : nous intervenons sur des architectures logicielles modernes (micro-services, API REST) pour améliorer l\'interopérabilité et l\'évolutivité.</li></ul>'
            }
        ]
    },
    {
        id: 'software-engineering',
        title: 'Ingénierie Logicielle',
        description:
            "<p>L’attractivité d'une <strong>infrastructure numérique</strong> repose aujourd’hui sur la conception d'architectures soutenant une <strong>croissance continue</strong>. Nous transformons vos <strong>besoins</strong> métiers en <strong>actifs logiciels</strong> durables en combinant <i>développement applicatif</i> de haute précision et <i>automatisation des cycles de production</i>.</p>" +
            "<p>Qu'il s'agisse de concevoir des <i>plateformes évolutives</i>, d'implémenter des <i>algorithmes de collecte de données</i> pour alimenter vos analyses, ou de déployer des <i>pipelines DevOps</i>, notre approche garantit une fiabilité totale.</p>",
        imageUrl: '/assets/images/illustrations/logiciel.jpeg',
        images: [
            '/assets/images/icons/c.png',
            '/assets/images/icons/c++.png',
            '/assets/images/icons/csharp.png',
            '/assets/images/icons/python.png',
            '/assets/images/icons/qt.png'
        ],
        services: [
            {
                id: 'architecture',
                title: 'Conception d\'architecture logicielle',
                summary: 'Définition d\'une architecture modulable pour vos applications critiques.',
                details:
                    '<p>Nous cadrons l\'architecture cible selon vos objectifs de performance, de sécurité et de scalabilité.</p><ul><li>Développement multi-langages avec une maîtrise avancée du C, de Java et de Python.</li><li>Gestion de la mémoire et optimisation des ressources pour des applications performantes.</li><li>Programmation full-stack incluant front-end, back-end et API REST.</li><li>Persistance des données sur bases relationnelles ou NoSQL selon les besoins métiers.</li></ul>'
            },
            {
                id: 'devops-pipeline',
                title: 'Mise en place de pipeline DevOps',
                summary: 'Automatisation CI/CD pour fiabiliser les livraisons et réduire les délais.',
                details:
                    '<p>Nous implémentons les chaînes de build, test et déploiement adaptées à votre contexte.</p><ul><li>Administration système et réseaux pour automatiser la maintenance et le diagnostic.</li><li>Cloud computing pour déployer et administrer des services sur des plateformes de référence.</li><li>Supervision et monitoring pour suivre les logs et les indicateurs de performance.</li><li>Architectures distribuées pour accompagner le passage à l\'échelle.</li></ul>'
            },
            {
                id: 'legacy-modernization',
                title: 'Algorithmes de Collecte de Données',
                summary: 'Outils de scraping et de parsing pour transformer les flux externes en données exploitables.',
                details:
                    '<p>Nous développons des outils de collecte performants pour transformer le web et vos flux externes en sources d\'information exploitables.</p><ul><li><strong>Extraction et parsing</strong> : analyse de structures textuelles complexes.</li><li><strong>Traitement de flux structurés</strong> : usage des expressions régulières pour filtrer et valider les données.</li><li><strong>Conception d\'algorithmes optimisés</strong> : exploration de graphes, d\'arbres et de structures complexes.</li><li><strong>Analyse de complexité</strong> : optimisation des temps d\'exécution pour de gros volumes.</li><li><strong>Gestion de l\'hétérogénéité</strong> : normalisation de données issues de sources variées.</li></ul>'
            }
        ]
    },
    {
        id: 'digital-identity',
        title: 'Création d’une identité numérique',
        description:
            "<p>Une identité numérique réussie repose sur une cohérence totale entre une vitrine web performante et un système de gestion de données structuré. Nous accompagnons les créateurs et entrepreneurs dans l’édification de leur socle technologique en concevant des solutions sur mesure, évolutives et sécurisées.</p>" +
            "<p>De la mise en ligne de votre premier portail interactif à l'implémentation d'une architecture de données robuste, nous transformons votre vision en une réalité technique prête pour le passage à l'échelle.</p>",
        imageUrl: '/assets/images/illustrations/web.jpeg',
        images: [
            '/assets/images/icons/wordpress.png',
            '/assets/images/icons/drupal.png',
            '/assets/images/icons/php.png',
            '/assets/images/icons/symfony.png',
            '/assets/images/icons/mysql.webp'
        ],
        services: [
            {
                id: 'showcase-site',
                title: 'Développement de Plateformes Web sur mesure',
                summary: 'Création ou refonte d\'un site qui valorise clairement votre offre.',
                details:
                    '<p>Nous concevons des plateformes web modernes, responsives et alignées avec vos objectifs métiers.</p><ul><li>Interfaces vitrines et interactives pour valoriser votre activité.</li><li>Solutions full-stack avec front-end et back-end intégrés.</li><li>Architectures évolutives pour accompagner la montée en charge.</li></ul>'
            },
            {
                id: 'brand-kit',
                title: 'Systèmes de Gestion de Données & Backend',
                summary: 'Structuration des données et sécurisation des traitements côté serveur.',
                details:
                    '<p>Nous structurons vos données et vos services serveur pour garantir l\'intégrité, l\'accessibilité et la maintenabilité de vos applications.</p><ul><li>Conception et modélisation de bases de données (MCD/MLD).</li><li>Centralisation de l\'information dans des SGBD relationnels ou NoSQL.</li><li>Sécurisation des actifs contre les injections et les failles courantes.</li></ul>'
            },
            {
                id: 'data-foundation',
                title: 'Infrastructure et Outillage Startup',
                summary: 'Mise en place d\'un socle technique pour lancer et faire évoluer un projet.',
                details:
                    '<p>Nous mettons en place un premier environnement technique capable d\'héberger, automatiser et structurer votre activité numérique.</p><ul><li>Déploiement cloud et automatisation des mises à jour.</li><li>Outils collaboratifs et versionnage de code pour organiser l\'équipe technique.</li><li>Accompagnement sur l\'identité professionnelle et les bonnes pratiques de communication numérique.</li></ul>'
            }
        ]
    }
]

export const PARTNER_LOGOS = [
    'ensgsi.png',
    'inria.png',
    'iae.png',
    'osul.png',
    'clinique_louis_pasteur.png',
    'rte.png',
    'societe_generale.png',
    'telecom.png',
    'transalliance.svg',
    'wig.png',
    'lcl.png'
]

export const FOOTER_LINKS = {
    facebook: [
        {
            name: 'Telecom Nancy Services',
            link: 'https://www.facebook.com/tnservices/'
        }
    ],
    linkedin: [
        {
            name: 'Telecom Nancy Services',
            link: 'https://www.linkedin.com/company/telecom-nancy-services/'
        }
    ]
}


